exports = module.exports = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "/* purgecss start ignore */\n.soundkit-pricing-cols[data-v-754ecc2c] {\n  grid-template-columns: repeat(auto-fill, minmax(307px, 1fr));\n}\n\n/* purgecss end ignore */\n", ""]);
